/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Permission = {
    ReadSimulations: 'ReadSimulations',
    WriteSimulations: 'WriteSimulations',
    DeleteSimulations: 'DeleteSimulations',
    AccessTestEndpoints: 'AccessTestEndpoints',
    ManageLelPrices: 'ManageLelPrices',
    ManageAdminSettings: 'ManageAdminSettings',
    CreatePrice: 'CreatePrice',
    ReadCalculationSettings: 'ReadCalculationSettings',
    WriteCalculationSettings: 'WriteCalculationSettings',
    NoveltyCalculation: 'NoveltyCalculation',
    CopyPrice: 'CopyPrice',
    CompareSimulations: 'CompareSimulations',
    ReadPrices: 'ReadPrices',
    DeleteNoveltyPrices: 'DeleteNoveltyPrices',
    EditSimulationPrices: 'EditSimulationPrices',
    EditSimulationSettings: 'EditSimulationSettings',
    ManageValueBasedPrices: 'ManageValueBasedPrices'
} as const;
export type Permission = typeof Permission[keyof typeof Permission];


export function instanceOfPermission(value: any): boolean {
    for (const key in Permission) {
        if (Object.prototype.hasOwnProperty.call(Permission, key)) {
            if (Permission[key as keyof typeof Permission] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PermissionFromJSON(json: any): Permission {
    return PermissionFromJSONTyped(json, false);
}

export function PermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Permission {
    return json as Permission;
}

export function PermissionToJSON(value?: Permission | null): any {
    return value as any;
}

export function PermissionToJSONTyped(value: any, ignoreDiscriminator: boolean): Permission {
    return value as Permission;
}

